export const CONFIRMER_PAIEMENT_MOYEN_PAIEMENT_FORM_NAME = "moyenPaiement";
export const FILE_FORM_NAME = "file";
